import styled from 'styled-components'

export const CheckboxContainer = styled.div`
	position: relative;
	[type="checkbox"] {
		position: absolute;
		width: 100%;
		height: 100%;
		left: 0;
		top: 0;
		opacity: 0;
		z-index: 1;
		cursor: pointer;
		&:checked + .tick svg{
			opacity: 1;
		}
	}
	svg {
		opacity: 0;
		transition: opacity 0.25s ease;
	}
`

export const CheckboxTick = styled.span`
	width: 24px;
	height: 24px;
	position: absolute;
	left: 0;
	top: 0;
	&:before {
		content: "";
		width: 100%;
		height: 100%;
		position: absolute;
		left: 0;
		top: 0;
		border: 0.1rem solid currentColor;
		opacity: 0.3;
	}
`
export const CheckboxLabel = styled.p`
	position: relative;
	padding-left: 40px;
	z-index: 2;
	pointer-events: none;
	a {
		pointer-events: all;
	}
	p {
		font-size: 18px !important;
	}
`
